<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="headingOnroerend">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseOnroerend" aria-expanded="false" aria-controls="collapseOnroerend">
                Onroerende zaken
            </button>
        </h2>
        <div id="collapseOnroerend" class="accordion-collapse collapse" aria-labelledby="headingOnroerend"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Bij een onroerende zaak gaat het om een schenking van een gebouw of werk is dat duurzaam met de grond is
                verbonden. Bijvoorbeeld woningen en winkelpanden. De grond is ook een onroerende zaak. Voor de verkoop
                van onroerende zaken is altijd een notariële koopakte verplicht. De vragen zijn ook van toepassing
                indien (een deel van) de koopsom van de onroerende zaak wordt kwijtgescholden.
                <div class="space20"></div>
                De waarde van onroerende zaken bij schenking wordt vastgesteld aan de hand van de WOZ-waarde, tenzij de
                werkelijke waarde hoger is. Voor niet-woningen (zoals bedrijfspanden) geldt meestal de marktwaarde. Bij
                familiaire overdracht onder de marktwaarde moet het verschil worden aangemerkt als een schenking.
                <div class="space20"></div>
                Belastbare schenkingen kunnen ook optreden bij zogeheten ‘verkoop met terughuur’ of bij gebruiksbehoud
                door de schenker. Bij schenking van verhuurde panden kan een correctie plaatsvinden voor de
                waardedrukkende werking van huurdersrechten.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingAfzonderlijkVerkoopbaar">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseAfzonderlijkVerkoopbaar" aria-expanded="false" aria-controls="collapseAfzonderlijkVerkoopbaar">
                Afzonderlijk verkoopbaar
            </button>
        </h2>
        <div id="collapseAfzonderlijkVerkoopbaar" class="accordion-collapse collapse" aria-labelledby="headingAfzonderlijkVerkoopbaar"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De vraag over 'afzonderlijk verkoopbaar' geeft aan of de geschonken woning, die onderdeel uitmaakt van een groter geheel, afzonderlijk verkocht kan worden.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingWaardeEV">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseWaardeEV" aria-expanded="false" aria-controls="collapseWaardeEV">
                Waarde economisch verkeer
            </button>
        </h2>
        <div id="collapseWaardeEV" class="accordion-collapse collapse" aria-labelledby="headingWaardeEV"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De 'waarde economisch verkeer' is de hoogste prijs die de onroerende zaak bij verkoop kan opbrengen in de staat waarin het verkeerde op de dag van de schenking. Dit wordt ook wel "marktwaarde" genoemd.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingWOZ">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseWOZ" aria-expanded="false" aria-controls="collapseWOZ">
                WOZ-waarde
            </button>
        </h2>
        <div id="collapseWOZ" class="accordion-collapse collapse" aria-labelledby="headingWOZ"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De 'WOZ-waarde' is de waarde van de onroerende zaak die staat op de WOZ-beschikking van de gemeente.
                Neem de waarde op 1 januari van het jaar van schenken, of op 1 januari van het jaar ná de schenking (als die bekend is). De laagste waarde mag worden ingevuld.
                Een vakantiewoning in het buitenland heeft geen WOZ-waarde.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingAandeel">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseAandeel" aria-expanded="false" aria-controls="collapseAandeel">
                Overgedragen aandeel onroerende zaak
            </button>
        </h2>
        <div id="collapseAandeel" class="accordion-collapse collapse" aria-labelledby="headingAandeel"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het 'overgedragen aandeel onroerende zaak' is het aandeel van de onroerende zaak dat wordt geschonken. Een woning kan gedeeltelijk geschonken worden, bijvoorbeeld als ouders ieder kind 1/2 van de onroerende zaak schenken.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingKoopsom">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseKoopsom" aria-expanded="false" aria-controls="collapseKoopsom">
                Koopsom onroerende zaak
            </button>
        </h2>
        <div id="collapseKoopsom" class="accordion-collapse collapse" aria-labelledby="headingKoopsom"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De 'koopsom onroerende zaak' is het bedrag dat de begiftigde betaalt aan de schenker voor het niet-geschonken deel.
                Bij verkoop onder de feitelijke waarde geldt het verschil tussen waarde en koopsom als schenking.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingKwijtschelding">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseKwijtschelding" aria-expanded="false" aria-controls="collapseKwijtschelding">
                Kwijtgescholden koopsom onroerende zaak
            </button>
        </h2>
        <div id="collapseKwijtschelding" class="accordion-collapse collapse" aria-labelledby="headingKwijtschelding"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Dit is het deel van de koopsom dat door de schenker is kwijtgescholden. Let op: kwijtschelding is iets anders dan verkoop onder de waarde; beide kunnen leiden tot schenkbelasting.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingErfpacht">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseErfpacht" aria-expanded="false" aria-controls="collapseErfpacht">
                Jaarlijkse erfpachtcanon
            </button>
        </h2>
        <div id="collapseErfpacht" class="accordion-collapse collapse" aria-labelledby="headingErfpacht"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De jaarlijkse erfpachtcanon is de jaarlijkse vergoeding die wordt betaald voor het gebruik van grond waarop de onroerende zaak staat.
                Vul hier het totale jaarlijkse bedrag in voor de geschonken onroerende zaak, evenals de formeel vastgelegde einddatum van de erfpacht.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingJaarhuur">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseJaarhuur" aria-expanded="false" aria-controls="collapseJaarhuur">
                Jaarhuur en verhuurde oppervlakte
            </button>
        </h2>
        <div id="collapseJaarhuur" class="accordion-collapse collapse" aria-labelledby="headingJaarhuur"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De 'jaarlijkse huur' is het bedrag dat jaarlijks wordt ontvangen voor het verhuurde deel van de woning.
                Bereken dit door de maandhuur te vermenigvuldigen met 12. Voor gedeeltelijke verhuur wordt het niet-verhuurde deel berekend met de WOZ-waarde vermenigvuldigd met (100% - verhuurd percentage).<br/><br/>
                <b>Verhuurde oppervlakte:</b> Deel het aantal m² dat is verhuurd door het totale oppervlak van de woning, en vermenigvuldig met 100 voor het percentage verhuurd oppervlak.<br/><br/>
                <b>Indicatie marktconform:</b> Huurprijzen worden als marktconform beschouwd als ze zijn gebaseerd op het woningwaarderingsstelsel (puntensysteem).
            </div>
        </div>
    </div>

</div>
